export default __webpack_public_path__ + "static/media/Foto31.c70a8e21.png";